// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorPage_container__VPUh3","image":"ErrorPage_image__tfQVv","code":"ErrorPage_code__OyBgJ","message":"ErrorPage_message__Etdwb","cta":"ErrorPage_cta__qaGuu"};